import { AsyncState } from 'react-async';
import { Async, AsyncErrorHandling, Rejected, Resolved } from '../../../common/async';
import * as accountService from '../account-service';
import { AccountModel } from '../models/account-model';
import { useParams } from 'react-router';
import { ReactNode } from 'react';

const getAccount = ({ id }): Promise<AccountModel> => accountService.getAdminAccount(id);

export interface FetchAccountProps {
    children: (account: AccountModel, state: AsyncState<AccountModel>) => ReactNode;
}

const FetchAccount = ({ children }: FetchAccountProps) => {
    const { accountId } = useParams();

    return (
        <Async promiseFn={getAccount} id={accountId}>
            <Resolved>{children}</Resolved>
            <Rejected>{error => <AsyncErrorHandling error={error} />}</Rejected>
        </Async>
    );
};

export default FetchAccount;
